import {
  AppBar,
  Button,
  DialogActions,
  DialogContent,
  Toolbar,
  Typography,
} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {
  openDialog,
  closeDialog as fuseCloseDialog,
} from "app/store/fuse/dialogSlice";

export default function showConfirmationDialog(dispatch, props) {
  dispatch(
    openDialog({
      maxWidth: props?.maxWidth || "sm",
      fullWidth: true,
      children: (
        <>
          <AppBar position="static" elevation={0}>
            <Toolbar className="flex w-full">
              <Typography variant="subtitle1" color="inherit">
                {props?.title}
              </Typography>
              <IconButton
                aria-label="close"
                onClick={() => {
                  if (props.onCancelBtnClick) props.onCancelBtnClick('close');
                  dispatch(fuseCloseDialog());
                }}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "white",
                }}
              >
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <DialogContent>
            <Typography id="alert-dialog-description">
              {props?.message}
            </Typography>
          </DialogContent>
          <DialogActions>
            {props?.displayCancelBtn && (
              <Button
                className="rounded-md"
                variant="contained"
                color="secondary"
                type="submit"
                onClick={() => {
                  if (props.onActionBtnClick) props.onActionBtnClick('close');
                  dispatch(fuseCloseDialog());
                }}
                sx={{ height: "35px", minHeight: "35px", maxHeight: "35px" }}
              >
                {props?.cancelActionName || "Cancel"}
              </Button>
            )}
            <Button
              className="rounded-md"
              variant="contained"
              color="secondary"
              type="submit"
              onClick={() => {
                if (props.onActionBtnClick) props.onActionBtnClick("submit");
                dispatch(fuseCloseDialog());
              }}
              sx={{ height: "35px", minHeight: "35px", maxHeight: "35px" }}
            >
              {props?.actionName || "Ok"}
            </Button>
          </DialogActions>
        </>
      ),
    })
  );
}
